import request from './request'

export const studentOfferApi = {
  listStudentOffer (params) {
    return request.get('/studentOffers', { params: params })
  },
  saveStudentOffer (data) {
    return request.post('/studentOffer', data)
  },
  deleteStudentOffer (id) {
    return request.delete('/studentOffers/' + id)
  },
  getStudentOffer (id) {
    return request.get('/studentOffers/' + id)
  },
  updateStudentOffer (id, data) {
    return request.put('/studentOffers/' + id, data)
  },
}

export default studentOfferApi
